export enum MilestoneRatioPeriod {
  OneWeek = 1,
  OneMonth = 2,
  ThreeMonths = 3,
  SixMoths = 4,
  TwelveMoths = 5,
}
